import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalloutComponent } from './callout.component';

import { IconModule } from '../icon/icon.module';
import { TitleModule } from '../title/title.module';
import { TextModule } from '../text/text.module';
import { ButtonModule } from '../button/button.module';
import { CloseActionModule } from '../close-action/close-action.module';

@NgModule({
  declarations: [CalloutComponent],
  imports: [CommonModule, IconModule, TitleModule, TextModule, ButtonModule, CloseActionModule],
  exports: [CalloutComponent],
})
export class CalloutModule {}
